import { DataGrid } from '@mui/x-data-grid';
import { ColumnsOptions, columns } from './columns';
import { Subdimension } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { subdimensionId } from '@features/campaigns/subdomains/visitation/utils';
import { ColumnTypeValue } from '../ColumnTypeSelect';
import { salesContributionMetricsColumns } from './salesContributionMetricsColumns';
import { Option } from './columns';
import { GridRowClassNameParams } from '@mui/x-data-grid';
import { ALL_OPTION } from '@features/campaigns/components/RealTimeOptimization/DimensionTabs';

const STATISTICALLY_INSIGNIFICANT_CLASSNAME = 'statistically-insignificant';

type DimensionsDataGridProps = {
  filterByDimension: string;
  subdimensions: Subdimension[];
  selectedOptimization: Option;
  onChangeOptimization: ColumnsOptions['setSelectedOptimization'];
  columnmType: ColumnTypeValue;
};

export const DimensionsDataGrid = (props: DimensionsDataGridProps) => {
  const {
    filterByDimension,
    subdimensions,
    selectedOptimization,
    onChangeOptimization,
  } = props;

  const rows = subdimensions
    .filter(
      subdimension =>
        filterByDimension === ALL_OPTION.value ||
        subdimension.name === filterByDimension
    )
    .map(subdimension => ({
      ...subdimension,
      id: subdimensionId(subdimension),
    }));

  const showSalesColumns = rows.some(subdimension => subdimension.salesMetrics);

  const dataGridColumns =
    props.columnmType === 'salesContributionMetrics' && showSalesColumns
      ? salesContributionMetricsColumns()
      : columns({
          selectedOptimization,
          showSalesColumns,
          setSelectedOptimization: onChangeOptimization,
        });

  return (
    <DataGrid
      rows={rows}
      columns={dataGridColumns}
      pageSizeOptions={[5, 10, 25]}
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 5,
          },
        },
        columns: {
          columnVisibilityModel: {
            transactionSizeLiftInStore: false,
            transactionRateLiftInStore: false,
            penetrationLiftInStore: false,
            transactionSizeLiftOnline: false,
            transactionRateLiftOnline: false,
            penetrationLiftOnline: false,
            exposedTransactionSizeInStore: false,
            exposedTransactionRateInStore: false,
            exposedPenetrationInStore: false,
            exposedTransactionSizeOnline: false,
            exposedTransactionRateOnline: false,
            exposedPenetrationOnline: false,
          },
        },
      }}
      getRowClassName={(params: GridRowClassNameParams<Subdimension>) =>
        params.row.statisticallySignificant
          ? ''
          : STATISTICALLY_INSIGNIFICANT_CLASSNAME
      }
      sx={{
        height: 'auto',
        padding: '1rem',
        '& .MuiDataGrid-columnHeader:focus, .MuiDataGrid-cell:focus': {
          outline: 'none',
        },
        '& .MuiDataGrid-columnHeaderTitleContainerContent': {
          whiteSpace: 'normal',
          height: '100%',
        },
        '& .MuiDataGrid-columnHeader': {
          height: 'auto !important',
          paddingBottom: '1rem',
        },
        '& .MuiDataGrid-columnHeaders': {
          maxHeight: 'unset !important',
          minHeight: 'unset !important',
          lineHeight: 'unset !important',
        },
        [`.${STATISTICALLY_INSIGNIFICANT_CLASSNAME}`]: {
          color: 'lightgray',
        },
      }}
      disableRowSelectionOnClick
      data-testid="dimensions-table"
    />
  );
};
